import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ToggleListComponent } from "./toggle-list.component";

@NgModule({
  declarations: [ToggleListComponent],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [ToggleListComponent],
})
export class ToggleListModule {}
